<template>
  <div class="receivers-list">
    <div class="text-input">
      <label class="required-flag">{{ $t('to') }}</label>
      <textarea
        v-hkldinput
        v-autosize
        v-fusioninputcheck="{
          type: 'string',
          tip: invalidEmailTip,
          pattern: validateEmails,
          classes: 'tooltip-class',
          required: true
        }"
        class="autosize"
        :value="displayTo"
        :required="true"
        @input="event => updateEmails(event, 'to')"
      />
    </div>
    <div class="text-input">
      <label>{{ $t('cc') }}</label>
      <textarea
        v-hkldinput
        v-autosize
        v-fusioninputcheck="{
          type: 'string',
          tip: invalidEmailTip,
          pattern: validateEmails,
          classes: 'tooltip-class',
          required: cc.trim()
        }"
        class="autosize"
        :value="displayCC"
        :required="cc.trim()"
        @input="event => updateEmails(event, 'cc')"
      />
    </div>
    <div class="text-input">
      <label>{{ $t('bcc') }}</label>
      <textarea
        v-hkldinput
        v-autosize
        v-fusioninputcheck="{
          type: 'string',
          tip: invalidEmailTip,
          pattern: validateEmails,
          classes: 'tooltip-class',
          required: bcc.trim()
        }"
        class="autosize"
        :value="displayBCC"
        :required="bcc.trim()"
        @input="event => updateEmails(event, 'bcc')"
      />
    </div>
  </div>
</template>

<script>
import { useEmailTool } from './hook'
import previewSubmissionModalMixin from './submissions/previewSubmissionModalMixin'

export default {
  mixins: [previewSubmissionModalMixin],
  setup () {
    const { to, cc, bcc } = useEmailTool()
    return {
      to,
      cc,
      bcc,
    }
  },
}
</script>
